import { useEffect } from 'react';

import { Redirect, useLocalSearchParams } from 'expo-router';
import { refetchLoyaltyUserSafely } from 'features/loyalty-user/refetch-loyalty-user-safely';

import { CardModal } from 'components/card-modal';
import { useAfterInteractions } from 'hooks/use-after-interactions';
import { LoyaltyHistory } from 'pages/loyalty/loyalty-history-modal';
import { HistorySkeleton } from 'pages/loyalty/loyalty-history-modal/components/history-skeleton';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyContext } from 'state/loyalty';
import { routes } from 'utils/routing';

export default function LoyaltyHistoryModalRoute() {
  const { refetchLoyaltyUser } = useLoyaltyContext();
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);
  const showContent = useAfterInteractions();
  const { transactionId } = useLocalSearchParams<{ transactionId?: string }>();

  useEffect(() => {
    refetchLoyaltyUserSafely(refetchLoyaltyUser, 'loyalty history modal');
  }, [refetchLoyaltyUser]);

  if (!enableLoyaltyProfile) {
    return (
      <Redirect
        href={
          transactionId
            ? { pathname: routes.rewardsHistory, params: { transactionId } }
            : routes.rewardsHistory
        }
      />
    );
  }

  return (
    <CardModal alwaysShowHeader headerText={t('historyTitle')} noDesktopWebMaxWidth>
      {showContent ? <LoyaltyHistory /> : <HistorySkeleton />}
    </CardModal>
  );
}
